import { styled } from '@linaria/react'

export const PopupAdapterSC = styled.div``
